import SocialMediaForm from './SocialMediaForm'

export default SocialMediaForm
